<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiEventForm",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
